import * as React from 'react';
import { IPart } from '../Utils/AutocompleteUtils';
import EDBox from '../../EDBox/EDBox';

interface IProps {
  wordBreak?: boolean;
  fontBold?: boolean;
  parts: IPart[];
}

/**
 * En text uppbyggd av flera mindre texter, där delar kan vara tydligt markerade.
 */
export const EDHighlightedText: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { parts } = props;

  return (
    <>
      {parts.map((part, index) => {
        return part.highlight ? (
          <EDBox
            component="span"
            key={index}
            sx={[
              Boolean(props.wordBreak) && { wordBreak: 'break-word' },
              {
                color: theme => theme.customProperties.highlightedTextColor,
                fontWeight: '600',
              },
              Boolean(props.fontBold) && {
                fontWeight: theme => theme.typography.fontWeightBold,
              },
            ]}
          >
            {part.text}
          </EDBox>
        ) : (
          <EDBox
            component="span"
            key={index}
            sx={[
              Boolean(props.wordBreak) && { wordBreak: 'break-word' },
              {
                color: theme => theme.customProperties.highlightedTextColor,
                fontWeight: '400',
              },
              Boolean(props.fontBold) && {
                fontWeight: theme => theme.typography.fontWeightBold,
              },
            ]}
          >
            {part.text}
          </EDBox>
        );
      })}
    </>
  );
};

export default EDHighlightedText;
